__turbopack_context__.v({
  "active": "ImageCarousel-module-scss-module__9jarQG__active",
  "carousel": "ImageCarousel-module-scss-module__9jarQG__carousel",
  "slide": "ImageCarousel-module-scss-module__9jarQG__slide",
});
